import angular, { isNumber } from "angular";

import "../../../services/user";
import "../../../services/countries";
import * as dawaAutocomplete from "dawa-autocomplete2";

angular.module("folkeuni").component("editUser", {
  templateUrl: "/shop-dist/templates/user-edit.html",
  transclude: false,
  controller: function (User, Countries, $scope, $element, $timeout) {
    // TO DO: Dava integration på adresse felter

    var $ctrl = this;
    $ctrl.loading = false;
    $ctrl.status = null;
    $ctrl.userCurrent = null;
    $ctrl.countries = [];

    $ctrl.passwordConfirmValid = function () {
      if ($ctrl.userCurrent) {
        if (
          !$ctrl.userCurrent.password &&
          !$ctrl.userCurrent.userPasswordConfirmed
        ) {
          return false;
        } else if (
          $scope.editUserForm.userPasswordConfirmed.$pristine ||
          $scope.editUserForm.userPassword.$pristine
        ) {
          return false;
        } else {
          return (
            $ctrl.userCurrent.password !=
            $ctrl.userCurrent.userPasswordConfirmed
          );
        }
      }
    };

    // Submit user details
    $ctrl.userEditUpdate = function (formData) {
      $ctrl.loading = true;
      $ctrl.status = null;
      if ($ctrl.userCurrent.countryObj.split(":")[0] == "DK") {
        $ctrl.userCurrent.country = "DK:DENMARK";
      } else {
        $ctrl.userCurrent.country = $ctrl.userCurrent.countryObj.toUpperCase();
      }

      if ($ctrl.userCurrent.employee) {
        $ctrl.userCurrent.employee.cpr = $ctrl.userCurrent.employee.cpr
          ? $ctrl.userCurrent.employee.cpr.replace("-", "")
          : null;
      }

      var newUser = Object.assign({}, $ctrl.userCurrent);

      if (isNumber($ctrl.userCurrent.phoneNumber)) {
        newUser.phoneNumber = $ctrl.userCurrent.phoneNumber.toString();
      }

      User.update(newUser).then(
        function (updateResponse) {
          $ctrl.loading = false;

          $ctrl.status = {
            success: true,
            message: "Din bruger er nu blevet opdateret.",
          };
        },
        function (errorResponse) {
          $ctrl.loading = false;
          $ctrl.status = {
            success: false,
            message:
              "Der skete en fejl, forsøg venligst igen. Hvis du stadig ikke lykkedes må du meget gerne kontakte os.",
          };
          console.log("error", errorResponse);
        }
      );
    };

    $ctrl.$onInit = function () {
      User.getCurrent().then(
        function (userObj) {
          for (var i in $ctrl.countries) {
            var currentCountry = $ctrl.countries[i];

            if (
              userObj.country.indexOf(":") > 0 &&
              currentCountry.code == userObj.country.split(":")[0]
            ) {
              userObj.countryObj = currentCountry.merge;
              userObj.country = currentCountry.merge;
              break;
            } else if (
              userObj.country &&
              userObj.country == currentCountry.code
            ) {
              userObj.countryObj = currentCountry.merge;
              break;
            }
          }

          $ctrl.userCurrent = userObj;
        },
        function (errorResponse) {
          console.log("Error", errorResponse);
        }
      );

      $ctrl.countries = Countries.getAllWithCombinedField();

      $timeout(function () {
        var streetnameInput = $element[0].querySelector(
          'input[ng-model="$ctrl.userCurrent.streetName"]'
        );
        if (streetnameInput) {
          dawaAutocomplete.dawaAutocomplete(streetnameInput, {
            select: function (selected) {
              $scope.$apply(function () {
                $scope.$ctrl.userCurrent.streetNumber = selected.data.husnr;
                $timeout(function () {
                  $scope.$ctrl.userCurrent.streetName = selected.data.vejnavn;
                }, 100);
                $scope.$ctrl.userCurrent.postalCode = Number(selected.data.postnr);
                $scope.$ctrl.userCurrent.city = selected.data.postnrnavn;
                $scope.$ctrl.userCurrent.floorNumber = selected.data.etage;
                if (
                  selected.data.dør != null &&
                  !isNaN(Number(selected.data.dør))
                ) {
                  $ctrl.$ctrl.userCurrent.roomNumber = selected.data.dør != undefined ? selected.data.dør.toString() : "";
                  $ctrl.$ctrl.userCurrent.side = "";
                } else {
                  $ctrl.$ctrl.userCurrent.side = selected.data.dør != undefined && selected.data.dør != null ? selected.data.dør.toString() : "";
                  $ctrl.$ctrl.userCurrent.roomNumber = "";
                }

                $timeout(function () {
                  streetnameInput.value = $scope.$ctrl.userCurrent.streetName;
                }, 150);
              });
            },
          });
        } else {
          console.error("Streetname input not found.");
        }
      }, 0);
    };
  },
});
